export default "__VITE_ASSET__Brc25$u1__"